import { getValue } from '../../components/values/Get';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { CustomPageValidatorFn } from '../../types/custom-page-validator';
import { formHasElementId } from '../../helpers/formHasElementId';

/**
 * Custom page validation for "oplysninger om passagerer page" used in various forms such as:
 * ramt-et-koeretoej-privat,
 * ramt-en-person-privat,
 * paakoert-bagfra-privat,
 * trafikale-skader-andet-privat,
 * paakoert-bagfra-erhverv
 *
 * At least one field in the group should be filled
 * @param formValues
 * @param formConfig
 * @param pageId
 * @returns
 */
export const customPageValidation: CustomPageValidatorFn = (
    formValues: FormValues | undefined,
    formConfig: FormConfig | undefined,
    pageId: string | undefined
) => {
    const getFieldNumber = (pageId: string) => {
        switch (pageId) {
            case 'om-modparten-1':
                return '1';
            case 'om-modparten-2':
                return '2';
            case 'om-modparten-3':
                return '3';
            case 'om-modparten-4':
                return '4';
        }
    };

    if (!formValues || !formConfig || !pageId) {
        return false;
    }

    const fieldNumber = getFieldNumber(pageId);

    const fields = [
        `otherInvolvedName-person${fieldNumber}`,
        `otherInvolvedAddress-person${fieldNumber}`,
        `otherInvolvedPhone-person${fieldNumber}`,
        `otherInvolvedInsuranceCompany-person${fieldNumber}`,
        `doYouHaveInformationAboutOthersInvolvedWhatHappenedToPerson-person${fieldNumber}`,
        `doYouHaveInformationAboutOthersInvolvedWhichThings-person${fieldNumber}`
    ];

    if (formHasElementId(formConfig, `doYouHaveInformationAboutOthersInvolvedLicensePlate-person${fieldNumber}`)) {
        fields.push(`doYouHaveInformationAboutOthersInvolvedLicensePlate-person${fieldNumber}`);
    }

    const fieldValues = fields.map((field: string) => {
        try {
            const value = getValue(formConfig, formValues, field);
            return value;
        } catch (error) {
            return '';
        }
    });

    return fieldValues.some((value: string) => value);
};
